import { render, staticRenderFns } from "./DirectEPrescribe.vue?vue&type=template&id=16195438"
import script from "./DirectEPrescribe.vue?vue&type=script&lang=js"
export * from "./DirectEPrescribe.vue?vue&type=script&lang=js"
import style0 from "./DirectEPrescribe.vue?vue&type=style&index=0&id=16195438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports